console.log("age gate running");

// Define a callback function to execute when mutations are observed
var callback = function(mutationsList, observer) {
    var element = $("#agp_row");
    if (element.length) {
      console.log("age gate present")

      // Create a <style> element
      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = '.fullscreen { width: 75% !important; height: 75% !important; max-width: 75% !important; font-size: 28px !important; font-family: "Antonio", sans-serif !important; background: url("https://cdn.shopify.com/s/files/1/0702/4633/4768/files/age-gate-background.png?v=1688591888") no-repeat center center fixed; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover !important; } .agp__disclaimer { display: none !important; }';
      // Append the <style> element to <head>
      document.getElementsByTagName('head')[0].appendChild(style);
      // Add the fullscreen class to the element
      element.addClass('fullscreen');
      // Once we've found the element, there's no need to keep observing
      observer.disconnect();
    }
};

// Create a new instance of `MutationObserver` named `observer`, passing it a callback function
var observer = new MutationObserver(callback);

// Call `observe()` on that observer instance, passing it the node to observe, and the options
observer.observe(document.body, { childList: true, subtree: true });
